import styled from 'styled-components';

export const ExternalSignInButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2em;
`;

export const ExternalSignInButtonWrapper = styled.div`
  width: 320px;
  height: 40px;
`;
